const DELETE = 'DELETE';
const GET = 'GET';
const PATCH = 'PATCH';
const POST = 'POST';
const PUT = 'PUT';

const PREFIX = process.env.GATEWAY_ENDPOINT || '';

export const getCsrfToken = () => {
  const csrfToken = document.querySelector('meta[name="csrf-token"]');
  return csrfToken && csrfToken.content;
};

const DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-CSRF-Token': getCsrfToken(),
};

const buildInit = (method, headers, options) => ({
  method,
  headers,
  ...options,
});

const createRequest = (method, url, options, headers) => {
  const init = buildInit(method, headers, options);
  return fetch(`${PREFIX}${url}`, init);
};

export default {
  get: (url, options = {}, headers = DEFAULT_HEADERS) => {
    return createRequest(GET, url, options, headers);
  },
  delete: (url, options = {}, headers = DEFAULT_HEADERS) => {
    return createRequest(DELETE, url, options, headers);
  },
  patch: (url, options = {}, headers = DEFAULT_HEADERS) => {
    return createRequest(PATCH, url, options, headers);
  },
  post: (url, options = {}, headers = DEFAULT_HEADERS) => {
    return createRequest(POST, url, options, headers);
  },
  put: (url, options = {}, headers = DEFAULT_HEADERS) => {
    return createRequest(PUT, url, options, headers);
  },
};
